import { Outlet } from 'react-router';
import Header from '@/component/inc/header.jsx';
import { NavigationProgress } from './NavigationProgress';

/**
 * HeaderOnlyLayout - Layout with Header only (no Footer).
 * Used for cart, checkout, and other pages where footer is not needed.
 * Child routes render via <Outlet />.
 */
export function HeaderOnlyLayout() {
  return (
    <>
      <NavigationProgress />
      <Header />
      <div className="page-wrapper">
        <Outlet />
      </div>
    </>
  );
}

export default HeaderOnlyLayout;
